import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'size',
})<{ color: string; size: number }>(({ color, size }) => ({
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: '2px',
  backgroundColor: color,
  flexShrink: 0,
}));

type Props = {
  color: string;
  size?: number;
  className?: string;
};

const ColorIndicator: FC<Props> = ({ color, size = 8, className }) => {
  return <StyledBox color={color} size={size} className={className} />;
};

export default ColorIndicator;
